import { render, staticRenderFns } from "./AnkenInfo.vue?vue&type=template&id=2fc7433c&scoped=true&"
import script from "./AnkenInfo.vue?vue&type=script&lang=js&"
export * from "./AnkenInfo.vue?vue&type=script&lang=js&"
import style0 from "./AnkenInfo.vue?vue&type=style&index=0&id=2fc7433c&scoped=true&lang=css&"
import style1 from "./AnkenInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7433c",
  null
  
)

export default component.exports